<template>
  <div @click="$emit('input', onClick())" >{{printableValue}}</div>
</template>

<script>
export default {
  data: function () {
    return {
      value: null
    }
  },
  props: {
    state: {
      type: Number,
      default: null
    }
  },
  computed: {
    printableValue: function () {
      switch (this.state) {
        case null: return '?'
        case 0: return '0'
        case 1: return '1'
        default: return '?'
      }
    }
  },
  methods: {
    onClick: function () {
      this.value = this.value === null ? 0 : (this.value === 0 ? 1 : 0)
      return this.value
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/tri-state.vue